import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScubaDivingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"scuba_diving"}/>
}
